import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();

export const withoutSearchParams = (value: string): string => {
  try {
    const url = new URL(value, window.location.origin);
    url.search = '';
    return url.toString();
  } catch {
    return `${window.location.origin}${window.location.pathname}`;
  }
};

const appInsights = new ApplicationInsights({
  config: {
    connectionString: import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING,
    extensions: [reactPlugin as any],
    enableAutoRouteTracking: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableCorsCorrelation: true,
    enableUnhandledPromiseRejectionTracking: true
  }
});

appInsights.addTelemetryInitializer((item) => {
  if (typeof item.baseData?.uri === 'string') {
    item.baseData.uri = withoutSearchParams(item.baseData.uri);
  }
  if (typeof item.baseData?.refUri === 'string') {
    item.baseData.refUri = withoutSearchParams(item.baseData.refUri);
  }
  const properties = item.baseData?.properties;
  if (typeof properties?.refUri === 'string') {
    properties.refUri = withoutSearchParams(properties.refUri);
  }
});

appInsights.loadAppInsights();

export { appInsights };
